import type { Channel } from '@/types';

/** Application / posting channels shown in recruiter UI (includes Internal). */
export const APPLICATION_SOURCES: Channel[] = [
  'LinkedIn',
  'Company Website',
  'Indeed',
  'Glassdoor',
  'InfoJobs',
  'Referral',
  'Internal',
  'Other',
];

export const CHANNEL_TO_BACKEND: Record<string, string> = {
  LinkedIn: 'linkedin',
  'Company Website': 'company_website',
  Indeed: 'indeed',
  Glassdoor: 'glassdoor',
  InfoJobs: 'infojobs',
  Referral: 'referral',
  Internal: 'internal',
  Other: 'other',
};

export const CHANNEL_FROM_BACKEND: Record<string, Channel> = {
  linkedin: 'LinkedIn',
  company_website: 'Company Website',
  indeed: 'Indeed',
  glassdoor: 'Glassdoor',
  infojobs: 'InfoJobs',
  referral: 'Referral',
  internal: 'Internal',
  other: 'Other',
};

export const POSTING_CHANNEL_CUSTOM = '__custom__';

export function channelDisplayLabel(ch: string): string {
  const normalized = ch.trim();
  if (!normalized) return 'Other';
  return CHANNEL_FROM_BACKEND[normalized] ?? normalized.replace(/_/g, ' ');
}

/** Value sent to API when creating/updating a posting channel. */
export function resolvePostingChannelForApi(selected: string, customLabel: string): string {
  const custom = customLabel.trim();
  if (selected === POSTING_CHANNEL_CUSTOM) {
    return custom || 'Other';
  }
  return selected;
}

export function channelToBackend(ch: string): string {
  if (CHANNEL_TO_BACKEND[ch]) return CHANNEL_TO_BACKEND[ch];
  return ch.trim().toLowerCase().replace(/\s+/g, '_').slice(0, 80);
}

export function channelFromBackend(ch: string): Channel {
  return CHANNEL_FROM_BACKEND[ch] ?? 'Other';
}

/** Raw channel label for UI when BE stores a custom slug or label. */
export function channelLabelFromBackend(ch: string): string {
  return channelDisplayLabel(ch);
}
